import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label } from "rbx";
import { BooleanInput, SystemCodeSelect } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";
import { useCompanyParameters } from "../../../utils/hooks";

const INITIAL_FILTER_STATE = {
  Active: true
};
function InventoryStorageDimsFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });
  const [finished, setFinished] = useState(false);
  const { data: params } = useCompanyParameters();
  const [where, setWhere] = useState({
    Category: "Inventory",
    CodeName: "InvStorageDim",
    CodeId_in: ["1", "2", "3"]
  });
  useEffect(() => {
    if (params && !finished && params.RecId) {
      let CodeId_in = ["1", "2", "3"];
      if (!params?.UsePrimaryStorageDimension) {
        CodeId_in = CodeId_in.filter(c => c !== "1");
      }
      if (!params?.UseSecondaryStorageDimension) {
        CodeId_in = CodeId_in.filter(c => c !== "2");
      }
      if (!params?.UseTertiaryStorageDimension) {
        CodeId_in = CodeId_in.filter(c => c !== "3");
      }
      setWhere({
        ...where,
        CodeId_in
      });
      setFinished(true);
    }
  }, [finished, params, where, where.CodeId_in]);
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({
      ...inputs,
      [e.target.name]: e.target.name.includes("RecIdRef")
        ? parseInt(value)
        : value
    });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Name"
            name="InvStorageDimRecIdRef"
            value={inputs.InvStorageDimRecIdRef}
            where={where}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
InventoryStorageDimsFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
InventoryStorageDimsFilters.defaultProps = {
  filters: {}
};
export default InventoryStorageDimsFilters;
